<template>
  <svg style="width: 22px; height: 22px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title>send</title>
    <path fill="currentColor" d="M2,21L23,12L2,3V10L17,12L2,14V21Z" />
  </svg>
</template>

<script>
export default {
  name: 'SendIcon',
};
</script>
